import { Filter } from '@anytag/shared-molecules';
import { useInfluencerPostsContext } from '../InfluencerPostsContext';
import { BasicFilter } from './BasicFilter';

export const InfluencerPostsFilter = () => {
  const { filter, setFilter, isEngagementPage } = useInfluencerPostsContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} />
    </Filter.Provider>
  );
};
